import { useState } from "react";
import { faqItems } from "@/mocks/guaData";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 w-full bg-background-100/70">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-1.5 text-xs font-semibold text-accent-800">
              <i className="ri-question-line"></i> 常见问题
            </span>
            <h2 className="font-heading mt-5 text-3xl md:text-4xl font-bold text-foreground-950 leading-snug">关于看瓜，你可能有这些疑问</h2>
            <p className="mt-4 text-base text-foreground-600 leading-relaxed">
              没找到答案？可以随时通过表单告诉我们，编辑团队会尽快为你解答。
            </p>
            <button
              onClick={() => document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" })}
              className="whitespace-nowrap cursor-pointer mt-6 inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              联系我们
            </button>
          </div>

          <div className="lg:col-span-8 flex flex-col gap-3">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q} className="overflow-hidden rounded-2xl border border-background-200 bg-background-50">
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 md:px-6 py-5 text-left"
                  >
                    <h3 className="font-heading text-[15px] md:text-base font-bold text-foreground-950">{f.q}</h3>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={`ri-add-line text-lg transition-transform duration-300 ${open ? "rotate-45" : ""}`}></i>
                    </span>
                  </button>
                  <div className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                    <div className="overflow-hidden">
                      <p className="px-5 md:px-6 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}